const getBaseURL = () => {
    const currentHost = window.location.hostname; 
    if (currentHost.startsWith('www.')) {
        return 'https://www.regaloparahombres.com';
    } else {
        return 'https://regaloparahombres.com';
    }
};

const baseURL = getBaseURL(); 

export default baseURL;
